const AppStyles = {
    h1: {
        fontWeight: '400'
    },
    h2: {
        fontWeight: '400',
        textAlign: 'left'
    },
    h3: {
        fontWeight: '400',
        textAlign: 'left'
    },
    h4: {
        fontWeight: '400',
        textAlign: 'left'
    },
    h5: {
        fontWeight: '400',
        textAlign: 'left'
    },
    pre: {
        background: '#f8f8f8'
    },
    container: {
        // textAlign: 'center',
        marginTop: '80px',
        padding: '15px'
    },
    section: {
        textAlign: 'left',
        padding: '0 1em'
    },
    lineBreak: {
        height: '0',
        borderBottom: '1px solid #ededed',
        margin: '1em 10%'
    },
    profileform: {
        display: 'inline-block',
        width: '640px',
        boxShadow: '0px 0px 2px 1px #e4e3e3',
        padding: '15px'
    },
    inputRow: {
        display: 'block',
        marginTop: '0.5em'
    },
    input: {
        width: '100%',
        fontSize: '1em',
        padding: '0.5em',
        boxSizing: 'border-box',
        outline: 'none',
        border: 'none',
        borderBottom: '2px solid #2196F3'
    },
    inputLabel: {
        display: 'block',
        textAlign: 'left'
    },
    actionRow: {
        display: 'flex',
        marginTop: '0.5em',
        textAlign: 'right'
    },
    action: {
        fontSize: '1em',
        border: 'none',
        outline: 'none',
        padding: '12px 50px',
        backgroundColor: '#ededed',
        cursor: 'pointer'
    },

    link: {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    error: {
        background: 'orange',
        padding: '0.5em'
    },
    leftAlign: {
        textAlign: 'left'
    },
    rightAlign: {
        textAlign: 'right'
    },
    leftFloat: {
        float: 'left'
    },
    rightFloat: {
        float: 'right'
    }
}

export default AppStyles
